import { ComponentProps } from 'react';
import { Trans } from '@lingui/macro';
import {
  LayoutDashboard,
  Logout,
  Ticket,
  Train,
  Wallet,
} from 'tabler-icons-react';

import { SideMenu } from '../../components/side-menu/side-menu';
import { SideMenuLink } from '../../components/side-menu/side-menu-link';
import { SwitchLang } from '../../components/switch-lang/switch-lang';
import { authStore } from '../../domains/auth/auth.store';
import { routeCabinet, routeLogout, routeSignIn } from '../../router/routes';

import styles from './main-side-menu.module.css';

type MainSideMenuProps = Omit<ComponentProps<typeof SideMenu>, 'links'>;

export const MainSideMenu = (props: MainSideMenuProps) => {
  return (
    <SideMenu
      {...props}
      links={({ close }) => [
        <SideMenuLink key="1" path="/" icon={Train} onClick={close}>
          <Trans>Поиск билетов</Trans>
        </SideMenuLink>,

        <SideMenuLink
          key="2"
          path={routeCabinet.path}
          icon={LayoutDashboard}
          onClick={close}
        >
          <Trans>Личный кабинет</Trans>
        </SideMenuLink>,

        <SideMenuLink
          key="3"
          path={routeCabinet.TICKETS.path}
          icon={Ticket}
          onClick={close}
        >
          <Trans>Мои билеты</Trans>
        </SideMenuLink>,

        <SideMenuLink
          key="4"
          path={routeCabinet.ORDERS.path}
          icon={Wallet}
          onClick={close}
        >
          <Trans>История заказов</Trans>
        </SideMenuLink>,

        authStore.hasAuth ? (
          <SideMenuLink
            key="5"
            path={routeLogout.path}
            icon={Logout}
            onClick={close}
          >
            <Trans>Выход</Trans>
          </SideMenuLink>
        ) : (
          <SideMenuLink
            key="5"
            path={routeSignIn.path}
            icon={Logout}
            onClick={close}
          >
            <Trans>Войти</Trans>
          </SideMenuLink>
        ),
      ]}
    >
      <div className={styles.switchLang}>
        <SwitchLang />
      </div>
    </SideMenu>
  );
};
